export const formula = /^!FORMULA\[(\d+)\]\[(-?\d+)\]\[(\d+)\]/
